import React from 'react';
import {ContentAdDesktop} from 'app/styles/content';
import {LoadingIndicator} from '@fupa/fupa-uikit';
import {useLocation} from 'react-router';
import {Helmet} from 'react-helmet-async';
import {TITLE_POSTFIX} from 'app/seo/seo.constants';
import {MyMatchesPlaceholder} from 'app/components/matchCalendar/MyMatchesPlaceholder';
import {Star} from '@mui/icons-material';

const MyMatchesUnauthorizedPage = ({loading}) => {
  const location = useLocation();
  const action = {
    onClick: () => (window.location = `/auth/login?redirectUrl=${encodeURIComponent(location.pathname)}`),
    label: 'Anmelden',
  };
  const meta = [
    {
      name: 'description',
      content: 'Melde dich an, um alle Spiele und Liveticker deiner Favoriten auf einen Blick zu sehen.',
    },
    {name: 'robots', content: 'noindex, follow'},
  ];

  const content = loading ? (
    <LoadingIndicator bgColor message='Deine persönlichen Inhalte werden geladen...' />
  ) : (
    <MyMatchesPlaceholder
      icon={<Star color='action' fontSize='inherit' />}
      message='Melde dich an und erstelle automatisch deinen persönlichen Spielekalender, indem du Favoriten hinzufügst.'
      action={action}
    />
  );

  return (
    <ContentAdDesktop bgColor top='7.125rem'>
      <Helmet title={`Meine Spiele${TITLE_POSTFIX}`} meta={meta} />
      {content}
    </ContentAdDesktop>
  );
};

export default MyMatchesUnauthorizedPage;
